export interface FileInfo {
  fileName: string;
  fileExtension: string;
  file: string;
}

/**
 * Parse widen document json and read url
 * @param widenDocument json string
 */
export function getWidenDocumentUrl(widenDocument: any): string {
  let url;
  if (widenDocument) {
    const widenJson = JSON.parse(widenDocument);
    url = widenJson.url;
  }
  return url;
}


export function extractFileInfoFromLink(link: string): FileInfo {
  // remove params ? and # if present in url
  // then splits this string by /
  const linkSplit = link.split(/[?#]/)[0].split('/');

  const file = linkSplit[linkSplit.length - 1].split('.');
  return {
    fileName:
      file.length > 2 ? [...file].slice(0, file.length - 1).join('.') : file[0],
    fileExtension: file.length > 1 ? file[1].toLowerCase() : '',
    file: linkSplit[linkSplit.length - 1],
  };
}
